import { EventRegistry } from '../../../../../domain/event/event.registry';
import { ReferenceTableEvent } from './reference-table.event';
export class ReferenceTableNameSetEvent extends ReferenceTableEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `reference-table/${payload.id}`,
            type: ReferenceTableNameSetEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
ReferenceTableNameSetEvent.subject = 'reference-table/aggregate/reference-table/ReferenceTableNameSetEvent';
ReferenceTableNameSetEvent.type = 'com.treeplotter.api.reference-table.nameSet.v1';
EventRegistry.register(ReferenceTableNameSetEvent.type, ReferenceTableNameSetEvent);
//# sourceMappingURL=reference-table-name-set.event.js.map